import MmenuLight from "mmenu-light";

export function mobileMenu() {
    if (!document.querySelector("#primary-nav")) {
        return;
    }

    const menu = new MmenuLight(
        document.querySelector("#primary-nav"),
        "(max-width: 1024px)"
    );

    const body = document.querySelector("body");

    const navigator = menu.navigation();
    const drawer = menu.offcanvas();

    document
        .querySelector("#primary-nav-toggle")
        .addEventListener("click", (evnt) => {
            evnt.preventDefault();
            if (body.classList.contains("mm-ocd-opened")) {
                drawer.close();
            } else {
                drawer.open();
            }
        });
}
